/** Shared brand links: the portal carries easyEnergy branding, powered by Chargee. */
export const EASYENERGY_SITE_URL = 'https://www.easyenergy.com'

/** How the brand's app and portal are called in copy. */
export const APP_NAME = 'easyEnergy-app'
export const PORTAL_NAME = 'Mijn easyEnergy'
export const CHARGEE_SITE_URL = 'https://chargee.energy'
/** The easyEnergy app (built together with Chargee). */
export const APP_STORE_URL = 'https://apps.apple.com/nl/app/easyenergy/id6748530275'
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.easyenergy.insights'

/**
 * Where "Open easyEnergy-app" goes: the app's store page on a phone (which opens
 * the app when it is installed), the easyEnergy website elsewhere.
 * TODO: replace with the app's deep link to device linking once it exists.
 */
export function chargeeAppUrl(userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent): string {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return APP_STORE_URL
  if (/Android/i.test(userAgent)) return PLAY_STORE_URL
  return EASYENERGY_SITE_URL
}
